import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import api from '../../plugins/api'

import user from './modules/user'
import account from './modules/account'
import info from './modules/info'
import visit from './modules/visit'
Vue.use(Vuex)
Vue.use(api(Vuex))

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    account,
    info,
    visit
  },
  plugins: [createLogger({})]
})
